import React, { Component } from 'react';
import Select from 'react-select';
import '../../Modal.css';
import { connect } from 'react-redux';
import { providers } from '../../../../apis/backend';

class AddModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      cities: [],
      name: ''
    };
  }

  clearState() {
    this.setState({
      id: '',
      cities: [],
      name: ''
    });
  }

  async providerRequest() {
    try {
      await providers
        .post(
          '/',
          {
            // "field in the db that you are adding: data to be added"
            // look in the backend/api/models to see which fields are required
            id: this.state.id,
            cities: this.state.cities.map((city) => city.value),
            name: this.state.name
          },
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(this.clearState())
        .catch((response) => {
          console.log(response);
          alert('Sorry, an error occurred. Please check your entries.');
        });
    } catch (err) {
      console.log('Request Failed.');
    }
  }

  render() {
    const cityOptions = this.props.cities.map((city) => {
      const option = {
        value: city.id,
        label: city.name
      };
      return option;
    });
    return (
      <div id="addModal" className="modal fade" style={{ overflow: 'scroll' }}>
        <div className="modal-dialog modal-dialog-centered lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Provider</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="input-group input-group-sm mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Provider Name
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  value={this.state.name}
                  placeholder="Provider Name"
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
              </div>
              <div className="input-group input-group-sm mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Cities
                  </span>
                </div>
                <Select
                  name="ProviderCities"
                  id="ProviderCities"
                  className="multiselector"
                  isMulti
                  value={this.state.cities}
                  options={cityOptions}
                  onChange={(e) => {
                    this.setState({ cities: e });
                  }}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => this.clearState()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-dark"
                data-dismiss="modal"
                onClick={() => {
                  this.providerRequest();
                }}
                disabled={!this.state.name != ''}
              >
                Add Provider
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cities: state.admin.admin.cities,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, {})(AddModal);
